import { render, staticRenderFns } from "./ServiceTemplateDialog.vue?vue&type=template&id=c1409658&scoped=true&"
import script from "./ServiceTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1409658",
  null
  
)

export default component.exports